import s from '../tasks/ReviewItemSummaryTask/ReviewItemSummaryTask.module.css';
import { Flex } from '@repo/ui/Flex';
import { Icon } from '@repo/ui/Icon';
import { ItemCard } from '../ItemCard/ItemCard';
import type { OrderItem } from '../../graphql/query/getOrder';
import { useExchangeInfo } from '../../hooks/useExchangeInfo';
import { useWorkflow } from '../../workflow/hooks';
import { getValidImageUrl } from '../../utils/image';

export const ExchangeVariantCard = ({ item }: { item: OrderItem }) => {
  const { selectedVariantDescription, sameProduct, selectedVariant } =
    useExchangeInfo({
      item,
    });
  const { order } = useWorkflow();

  // Get parent item's image as fallback
  const parentItem = order?.items?.find(
    (orderItem) => orderItem.id === item.id,
  );
  const parentItemImage = parentItem?.image?.url;

  return (
    <ItemCard
      className={s.itemCardWrapper}
      imageSize="sm"
      image={getValidImageUrl(selectedVariant?.image, parentItemImage)}
      padding="p-8"
    >
      <Flex
        direction="column"
        justifyContent="space-evenly"
        alignItems="center"
      >
        <div className={s.itemDescription}>
          {!sameProduct && (
            <strong className={s.itemTitle}>{selectedVariant?.name}</strong>
          )}
          {selectedVariantDescription}
        </div>
      </Flex>
      <Flex alignItems="center" grow="1" justifyContent="flex-end">
        <Icon name="exchange" size="lg" className={s.exchangeCardIcon} />
      </Flex>
    </ItemCard>
  );
};
